import { useEffect, useState, startTransition } from "react"
import styled from "@emotion/styled"

import { useViewport } from "contexts/Viewport"

import { useConsole } from "contexts/Console"
import getMediaQuery from "css/breakpoints"
import { fullGrid } from "css/grid"
import { headline50 } from "css/text"

import { Provider } from "./context"
import SpecsFeaturesDesktop from "./SpecsFeaturesDesktop"
import SpecsFeaturesMobile from "./SpecsFeaturesMobile"

const Root = styled.section`
  ${fullGrid}
  grid-template-rows: [top-row title] auto [fig] auto [desclist] auto [bottom-row];
  padding-block: 10vh;

  background: white;

  ${getMediaQuery("m")} {
    grid-template-rows: [top-row title] auto [desclist] auto [bottom-row];
  }
`

const Heading = styled.header`
  grid-column: col 1 / col -1;
  grid-row: title;
  align-self: end;

  ${getMediaQuery("m")} {
    grid-column: col 7 / span 6;
  }
`

const Title = styled.h2`
  ${headline50}
  & em {
    font-style: normal;
    color: rgb(var(--green));
  }

  margin-block-end: 40px;
  ${getMediaQuery("m")} {
    margin-block-end: 60px;
  }
`

export default function SpecsFeatures({ heading, spec_items, className }) {
  const console = useConsole()

  const { isMobile } = useViewport()

  const [mobile, setMobile] = useState(isMobile.get())

  function onBp(bool) {
    startTransition(() => setMobile(bool))
  }
  useEffect(() => isMobile.onChange(onBp))

  return (
    <Provider>
      <Root className={className}>
        <Heading>
          <Title dangerouslySetInnerHTML={{ __html: heading }} />
        </Heading>
        {mobile ? <SpecsFeaturesMobile spec_items={spec_items} /> : <SpecsFeaturesDesktop spec_items={spec_items} />}
      </Root>
    </Provider>
  )
}
